<template>
  <footer class="footer-box">
    <div class="copy-info">
      Copyright © {{ year }} <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">粤ICP备2021148144号-10</a> 广州锐动网络科技有限公司
      <!-- 若已办理公安机关联网备案，请在此处补充备案号并链接至 https://beian.mps.gov.cn/ -->
    </div>
  </footer>
</template>

<script>
export default {
  name: 'footerItem',
  data() {
    return {
      year: new Date().getFullYear(),
    }
  },
}
</script>

<style lang="less" scoped>
.footer-box {
  height: 53px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #333;
  color: #999;

  .copy-info > div {
    padding: 10px;
    font-size: 12px;
    cursor: default;
  }
}
</style>
